import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import { isAdminDashboard } from 'utils/authScopes';

const GroupCohortsHeader = ({ ages, auth, meta }) => {
  const headers = meta.withages ? map(ages, a => <th key={a.value}>{a.label}</th>) : null;
  return (
    <thead>
      <tr>
        { isAdminDashboard(auth) && <th>Partner</th> }
        <th>Organization Type</th>
        <th>Title</th>
        <th>Level</th>
        <th># of Children</th>
        { headers }
        <th>Completed ASQ-SE2 surveys</th>
        <th>Completed ASQ-3 surveys</th>
      </tr>
    </thead>
  );
}

GroupCohortsHeader.propTypes = {
  ages: PropTypes.arrayOf(PropTypes.object).isRequired,
  auth: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
}

export default GroupCohortsHeader;